import { Fragment, useMemo } from 'react';
import { Grid } from '@mui/material';
import { StepButton, StepTypography } from 'shell/components/shared/step-button';
import { useFormikContext } from 'formik';
import { CohabitationDetailForm } from 'cohabitation/view-models/detail-cohabitation';
import Close from '@mui/icons-material/Close';
import { Check } from '@mui/icons-material';

interface CohabitationEditPageButtonsProps {
  stepState: number;
  handleStep: (step: number) => void;
}

const CohabitationEditPageButtons = ({
  stepState,
  handleStep,
}: CohabitationEditPageButtonsProps): React.ReactElement => {
  const formContext = useFormikContext<CohabitationDetailForm>();

  const errorsCohabitation = useMemo(() => {
    return !!formContext.errors.accordionCohabitation;
  }, [formContext.errors.accordionCohabitation]);

  const errorsGenerality = useMemo(() => {
    return !!formContext.errors.person || !!formContext.errors.generality;
  }, [formContext.errors.generality, formContext.errors.person]);

  const errorsResidence = useMemo(() => {
    return !!formContext.errors.residence;
  }, [formContext.errors.residence]);

  return (
    <Fragment>
      <Grid container item xs={12} spacing={1}>
        <Grid item xs={12}>
          <StepButton
            variant="outlined"
            active={stepState === 0}
            fullWidth
            color="cdmBrandThird"
            onClick={() => handleStep(0)}
          >
            <StepTypography active={stepState === 0}>Convivenza</StepTypography>
            {errorsCohabitation ? <Close color="error" /> : <Check color="success" />}
          </StepButton>
        </Grid>
        <Grid item xs={12}>
          <StepButton
            variant="outlined"
            active={stepState === 1}
            fullWidth
            color="cdmBrandThird"
            onClick={() => handleStep(1)}
          >
            <StepTypography active={stepState === 1}>Residenza</StepTypography>
            {errorsResidence ? <Close color="error" /> : <Check color="success" />}
          </StepButton>
        </Grid>
        <Grid item xs={12}>
          <StepButton
            variant="outlined"
            active={stepState === 2}
            fullWidth
            color="cdmBrandThird"
            onClick={() => handleStep(2)}
          >
            <StepTypography active={stepState === 2}>Intestatario</StepTypography>
            {errorsGenerality ? <Close color="error" /> : <Check color="success" />}
          </StepButton>
        </Grid>
      </Grid>
    </Fragment>
  );
};

CohabitationEditPageButtons.displayName = 'Cohabitation Insert buttons page component';

export default CohabitationEditPageButtons;
